/* eslint-disable */
import React, { useState } from 'react';
import {
  Button, Grid, Dialog, DialogTitle, DialogActions, DialogContent, TextField, Typography,
} from '@material-ui/core';
import Loading from '../../../components/loading/Loading';

export default function Boleto({ open, setOpen, onSave, loading }) {
  const [barcode, setBarcode] = useState('');
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setFileName(selected.name);
    }
  };

  const handleSave = () => {
    onSave({ barcode, file });
  };

  const handleClose = () => {
    setBarcode('');
    setFile(null);
    setFileName('');
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <Loading open={loading} msg="Salvando boleto..." />
      <DialogTitle>Boleto</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>

          {/* Código de Barras */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Código de Barras"
              variant="outlined"
              value={barcode}
              onChange={e => setBarcode(e.target.value)}
              placeholder="Digite o código de barras do boleto"
              inputProps={{ maxLength: 100 }}
            />
          </Grid>

          {/* Upload do Boleto */}
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              component="label"
              fullWidth
              style={{ height: 56 }}
            >
              {fileName || 'Anexar arquivo do boleto (opcional)'}
              <input
                type="file"
                hidden
                accept="application/pdf,image/*"
                onChange={handleFileChange}
              />
            </Button>
            {fileName && (
              <Typography variant="caption" style={{ marginTop: 4, display: 'block', color: '#717171' }}>
                Arquivo selecionado: {fileName}
              </Typography>
            )}
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button style={{ height: 40 }} onClick={handleClose} variant="text" color="primary">
          Cancelar
        </Button>
        <Button
          style={{ height: 40 }}
          onClick={handleSave}
          disabled={loading || (!barcode.trim() && !file)}
          variant="contained"
          color="primary"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}